import PropTypes from "prop-types";
import { PureComponent } from "react";
import "./product-header.scss";
import { PRODUCT_CATEGORY_TYPES } from "app/constants";
import ProductDestinationTitleContainer from "app/pages/.shared/ProductDestinationTitle/ProductDestinationTitleContainer";
import ProductNameWithCategory from "app/pages/.shared/ProductNameWithCategory/ProductNameWithCategory";

class ProductHeader extends PureComponent {
	render() {
		const { name, category, categoryType, region, resort, country } = this.props;

		return (
			<header className="product-header" data-testid="product-header">
				<ProductDestinationTitleContainer
					className="product-header__title"
					resort={resort}
					region={region}
					country={country}
				/>
				<ProductNameWithCategory
					category={category}
					categoryType={categoryType}
					name={name}
				/>
			</header>
		);
	}
}

ProductHeader.propTypes = {
	category: PropTypes.number,
	categoryType: PropTypes.oneOf([PRODUCT_CATEGORY_TYPES.TRIDENT, PRODUCT_CATEGORY_TYPES.STAR]),
	name: PropTypes.string,
	region: PropTypes.string,
	resort: PropTypes.string,
	country: PropTypes.string,
};

export default ProductHeader;
